import { EMPTY } from 'rxjs';
import { mapTo, catchError, tap } from 'rxjs/operators';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

export function apiInitializerFactory(
  apiUrl: string,
  httpClient: HttpClient,
): () => boolean | Promise<boolean> {
  return () => {
    if (location.pathname === '/connection-refused') {
      return true;
    }
    const headers = new HttpHeaders().set('X-fs-no-auth', '');
    return httpClient
      .get(`${apiUrl}/api/public/connectivity-check/`, {
        headers,
      })
      .pipe(
        tap((resp: any) => {
          localStorage.setItem('IS_CONTROLLED', resp.envIsControlled ? '1' : '0');
          localStorage.setItem('backendVersion', resp.version);
          localStorage.setItem('LPR_API', resp.domains?.lprApi ?? '');
          localStorage.setItem('LISTEN_API', resp.domains?.listenApi);
          localStorage.setItem('PANIC_API', resp.domains?.panicApi);
        }),
        mapTo(true),
        catchError((errorResponse: HttpErrorResponse) => {
          if (errorResponse.status === 0) {
            location.replace(location.origin + '/connection-refused');
          }

          return EMPTY;
        }),
      )
      .toPromise();
  };
}
